<div class="label flex-row g-space-sm justify-end">
  <div>
    {{
      'communication.message.system.cases.sub-task-created.title'
        | translate: { title: this.case().TaskReference ?? '' }
    }}
  </div>
  @if (this.case().AssigneeId) {
    <div>
      {{
        'communication.message.system.cases.sub-task-created.assignee'
          | translate
            : {
                name: this.getConversationParticipant(this.case().AssigneeId),
              }
      }}
    </div>
  }
</div>
